import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from '../propertyQueryKeys'
import { getPropertyAuditLogs } from '../propertyEndpoints'

export function usePropertyAuditLogsQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => propertyKeys.auditLogs(toValue(id)),
    queryFn: () => getPropertyAuditLogs(toValue(id)),
    enabled: () => Boolean(toValue(id)),
  })
}
